export type SnapOperationKind =
  | 'snaplink-enable'
  | 'snaplink-disable'
  | 'snappage-enable'
  | 'snappage-disable'
  | 'snappage-sheet-sync';

export interface SnapOperationOverlayState {
  kind: SnapOperationKind;
  title: string;
  detail: string;
  startedAt: number;
  blocking: boolean;
}

export const SNAP_OPERATION_ACTIVE_KEY = 'snaplayer.editor.snap-operation-active';
export const SNAP_OPERATION_EVENT = 'snaplayer:snap-operation-state';
export const EDITOR_VISIBILITY_EVENT = 'snaplayer:editor-visibility';

export function createSnapOperation(
  kind: SnapOperationKind,
  title: string,
  detail: string,
  options: { blocking?: boolean; startedAt?: number } = {},
): SnapOperationOverlayState {
  return {
    kind,
    title,
    detail,
    startedAt: options.startedAt ?? Date.now(),
    blocking: options.blocking ?? true,
  };
}

export function writeSnapOperationActive(active: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(SNAP_OPERATION_ACTIVE_KEY, active ? '1' : '0');
  } catch {
    void 0;
  }
  window.dispatchEvent(
    new CustomEvent(SNAP_OPERATION_EVENT, {
      detail: { active },
    }),
  );
}

export function readSnapOperationActive(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(SNAP_OPERATION_ACTIVE_KEY) === '1';
  } catch {
    return false;
  }
}
